<template>
  <div class="eval">
    <div class="eval_title">
      <span :class="{ active: activeType === 1 }" @click="activeTypeChoose(1)">{{
        $t("msg_title")
      }}</span>
      <span :class="{ active: activeType === 2 }" @click="activeTypeChoose(2)">{{
        $t("leaveHis")
      }}</span>
      <span class="eval_close" @click="close()"></span>
    </div>
    <div class="eval_body scroll_bar" v-if="activeType === 1">
      <div class="top-tip-txt">
        <p>
          {{ $t("txbj") }}
        </p>
      </div>
      <span class="label"> <span class="required">*</span>{{ $t("leaveMsgCon") }}</span>
      <el-input type="textarea" v-model="msgContent" />

      <span class="label">{{ $t("enclosure") }}</span>
      <el-upload
        class="upload-demo"
        action="/api/chat/visitor/upload"
        :on-preview="handlePreview"
        accept="image/png,image/jpg,image/heic,image/jpeg,video/mp4,video/mov,video/avc,video/hevc"        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-success="getRes"
        :before-upload="checkFileExist"
        :on-change="changeFile"
        multiple
        :limit="3"
        :file-list="fileList"
      >
        <el-button size="small" type="text" class="uploadBtn"
          >{{ $t("enclosure") }}
        </el-button>
      </el-upload>

      <el-form label-position="top" :inline="true" ref="woForm">
        <div v-if="extendsField.length > 0">
          <!-- 单行 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 1">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-input
                clearable
                v-model="item.chooseValue"
                type="text"
                :placeholder="$t('input')"
              />
            </div>
          </div>

          <!-- 多行 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 2">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-input
                clearable
                v-model="item.chooseValue"
                type="textarea"
                :placeholder="$t('input')"
              />
            </div>
          </div>

          <!-- 日期 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 3">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-date-picker
                v-model="item.chooseValue"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('input')"
                align="right"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 时间 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 4">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-date-picker
                type="datetime"
                v-model="item.chooseValue"
                format="yyyy-MM-dd HH:mm"
                :placeholder="$t('input')"
                align="right"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 数字 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 5">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-input-number
                clearable
                v-model="item.chooseValue"
                type="textarea"
                :placeholder="$t('input')"
              />
            </div>
          </div>

          <!-- 下拉 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 6">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-select
                style="width: 100%"
                :placeholder="$t('input')"
                v-model="item.chooseValue"
              >
                <el-option
                  v-for="val in item.fieldValue"
                  :key="val.name"
                  :label="val.name"
                  :value="val.name"
                />
              </el-select>
            </div>
          </div>

          <!-- 单选 -->
          <div
            class="mt10"
            v-for="item in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 7">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-radio-group v-model="item.chooseValue">
                <el-radio
                  v-for="val in item.fieldValue"
                  :key="val.name"
                  :label="val.name"
                  :value="val.name"
                  >{{ val.name }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>

          <!-- 复选 -->
          <div
            class="mt10"
            v-for="(item, index) in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 8">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-checkbox-group
                @change="CheckChange(item, index)"
                v-model="item.chooseValue"
              >
                <el-checkbox
                  v-for="(val, index) in item.fieldValue"
                  :key="index"
                  :label="index"
                >
                  {{ val.name }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <!-- 组合   -->
          <div
            class="mt10"
            v-for="(item, index) in extendsField"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
            <div class="form_item" v-if="item.fieldType == 9">
              <div>
                <span v-if="item.requiredStatus" class="red">*</span>
                <span> {{ item.fieldName }}</span>
              </div>
              <el-cascader
                :placeholder="$t('input')"
                :options="item.fieldValue"
                :props="optionProps2"
                filterable
                ref="zdy"
                @change="formFieldchange(item, index)"
              >
              </el-cascader>
            </div>
          </div>
        </div>
      </el-form>

      <Button
        style="background: #7467f0; margin-top: 10px"
        type="default"
        size="normal"
        @click="submitAction"
        >{{ $t("submit") }}
      </Button>
    </div>
    <div v-if="activeType === 2" class="eval_body scroll_bar">
      <div
        v-if="!showFlag"
        @click="showDetail(item)"
        class="leave_msg_item"
        v-for="item in list"
      >
        <div>
          <span class="time">{{ formDate(item.createTime) }}</span>
          <span class="woStatus"> {{ workOrderStateList[item.woStatus] }}</span>
        </div>
        <div>
          <span class="label">{{ $t("leaveMsgCon") }}</span>
          <span class="woContent">{{ item.woContent }}</span>
        </div>
      </div>
      <div v-if="showFlag">
        <el-steps class="font12 scroll_bar h300" direction="vertical">
          <el-step
            :active="active"
            v-for="item in orderDetail.handle"
            :key="'step' + item.handleTime"
          >
            <template slot="icon">
              <span class="bg"></span>
            </template>
            <template slot="title">
              <div class="pannel his_title">
                <span v-if="item.handleUserName" class="name sub">{{
                  item.handleUserName == "customer" ? $t("client") : $t("customer")
                }}</span>
                <span v-if="!item.handleUserName" class="name sub">{{
                  $t("client")
                }}</span>

                <span class="time sub sub_title">{{ formDate(item.handleTime) }}</span>
              </div>
            </template>
            <template slot="description">
              <div class="his_item">
                <div class="pannel">
                  <span class="sub2">{{ $t("orderPriority") }}:</span>
                  <span> {{ levelLists[item.handleWoLevel] }}</span>
                </div>
                <div class="pannel">
                  <span class="titl">{{ $t("orderStatus") }}:</span>
                  <span> {{ workOrderStateList[item.handleWoStatus] }}</span>
                </div>
                <div class="pannel">
                  <span class="titl fl">{{ $t("reply") }}:</span>
                  <span class="qp" v-html="item.handleContent"></span>
                </div>
              </div>
            </template>
          </el-step>
        </el-steps>
        <div class="mt20">
          <div class="form_item">
            <div>
              <span class="red">*</span>
              <span>{{ $t("reply") }}</span>
            </div>
            <el-input
              type="textarea"
              v-model="msgContent"
              :placeholder="$t('pleInput')"
            />
          </div>

          <div class="form_item">
            <div>
              <span>{{ $t("enclosure") }}</span>
            </div>

            <el-upload
              class="upload-demo"
              action="/api/chat/visitor/upload"
              :on-preview="handlePreview"
              accept="image/png,image/jpg,image/heic,image/jpeg,video/mp4,video/mov,video/avc,video/hevc"              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="getRes"
              :before-upload="checkFileExist"
              :on-change="changeFile"
              multiple
              :limit="3"
              :file-list="fileList"
            >
              <el-button size="small" type="text" class="uploadBtn"
                >{{ $t("enclosure") }}
              </el-button>
            </el-upload>
          </div>
          <Button
            style="background: #7467f0; margin-top: 10px"
            type="default"
            size="normal"
            @click="addWoHandleInfo"
            >{{ $t("submit") }}
          </Button>
        </div>
        <!-- <Button
          style="background: #7467f0; margin-top: 10px; width: 100%"
          type="default"
          size="normal"
          @click="showGFN"
          >{{ $t("submit") }}
        </Button> -->
      </div>
    </div>

    <el-drawer
      :append-to-body="true"
      :modal-append-to-body="false"
      :transfer="false"
      size="100%"
      direction="rtl"
      :visible.sync="showGroup"
    >
      <div class="form_item">
        <div>
          <span class="red">*</span>
          <span>{{ $t("reply") }}</span>
        </div>
        <el-input type="textarea" v-model="msgContent" :placeholder="$t('pleInput')" />
      </div>

      <div class="form_item">
        <div>
          <span>{{ $t("enclosure") }}</span>
        </div>

        <el-upload
          class="upload-demo"
          action="/api/chat/visitor/upload"
          :on-preview="handlePreview"
          accept="image/png,image/jpg,image/heic,image/jpeg,video/mp4,video/mov,video/avc,video/hevc"          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-success="getRes"
          :before-upload="checkFileExist"
          :on-change="changeFile"
          multiple
          :limit="3"
          :file-list="fileList"
        >
          <el-button size="small" type="text" class="uploadBtn"
            >{{ $t("enclosure") }}
          </el-button>
        </el-upload>
      </div>
      <Button
        style="background: #7467f0; margin-top: 10px"
        type="default"
        size="normal"
        @click="addWoHandleInfo"
        >{{ $t("submit") }}
      </Button>
    </el-drawer>
  </div>
</template>

<script>
import { Button } from "mint-ui";
import chatApi from "../methods";

import urlParams from "../../api/urlParams";

import store from "../../store/index";

import request from "../../api/request";
export default {
  name: "message",
  data() {
    return {
      msgContent: "",
      customerEmail: "",
      customerName: "",
      customerPhone: "",
      activeType: 1,
      showGroup: false,
      active: 0,
      list: [],
      extendsField: [],
      Field: [],
      chooseList: [],

      optionProps2: {
        value: "id",
        label: "name",
        children: "children",
      },
      fileList: [],
      showFlag: false,
      orderDetail: {},
      levelLists: {
        0: this.$t("orderLow"),
        1: this.$t("orderNormal"),
        2: this.$t("orderWarning"),
        3: this.$t("orderDanger"),
      },
      workOrderStateList: {
        99: this.$t("orderOver"),
        0: this.$t("orderNoYet"),
        1: this.$t("orderAccept"),
        2: this.$t("orderWait"),
        3: this.$t("serviceResolved"),
        5: this.$t("orderOver"),
      },
    };
  },
  mounted() {
    const that = this;
    var locale = urlParams("locale") || "zh";
    request
      .getTemplateFiledInfoByTypeId({
        tenantId: store.state.initData.tenantId,
        locale: locale,
      })
      .then((res) => {
        this.typeId = res.data.woType.typeId;
        this.typeName = res.data.woType.typeName;
        this.extendsField = [];
        that.Field = res.data.items;
        this.Field.forEach((item) => {
          if (item.fieldValue) {
            item.fieldValue = JSON.parse(item.fieldValue);
          }
        });
        for (let i = 0; i < that.Field.length; i++) {
          if (that.Field[i].fieldType == 8) {
            this.extendsField.push({
              fieldId: this.Field[i].fieldId,
              fieldName: this.Field[i].fieldName,
              fieldType: this.Field[i].fieldType,
              fieldValue: this.Field[i].fieldValue,
              chooseValue: [],
              chooseName: [],
              requiredStatus: this.Field[i].requiredStatus,
            });
          } else {
            this.extendsField.push({
              fieldId: this.Field[i].fieldId,
              fieldName: this.Field[i].fieldName,
              fieldType: this.Field[i].fieldType,
              fieldValue: this.Field[i].fieldValue,
              chooseValue: "",
              requiredStatus: this.Field[i].requiredStatus,
            });
          }
        }
        console.log(this.extendsField);
      });

    this.showFlag = false;
  },
  components: {
    Button,
  },
  computed: {
    initData() {
      return this.$store.state.initData;
    },
  },
  methods: {
    formDate(value, fmt) {
      if (!value) {
        return "--";
      }
      fmt = fmt || "yyyy-MM-dd hh:mm:ss";
      if (value && value < 10000000000) {
        value = value * 1000;
      }

      let getDate = new Date(value * 1);
      let o = {
        "M+": getDate.getMonth() + 1,
        "d+": getDate.getDate(),
        "h+": getDate.getHours(),
        "m+": getDate.getMinutes(),
        "s+": getDate.getSeconds(),
        "q+": Math.floor((getDate.getMonth() + 3) / 3),
        S: getDate.getMilliseconds(),
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },

    activeTypeChoose(type) {
      this.showFlag = false;
      this.msgContent = [];
      this.fileList = [];
      this.activeType = type;
      if (type === 2) {
        this.getLeaveMsg();
      }
    },
    getLeaveMsg() {
      this.msgContent = [];
      this.fileList = [];

      request
        .queryWoByCustom({
          userId: store.state.userInfo.userId,
          tenantId: store.state.initData.tenantId,
        })
        .then((res) => {
          console.log(res, "工单列表");
          this.list = res.data.list;
        });
    },
    submitAction() {
      var param = {
        cusFieldConfigInfoVoList: [],
        partnerId: "",
        userId: store.state.userInfo.userId,
        tenantId: store.state.initData.tenantId,
        woContent: this.msgContent,
        woFileRelVoList: [],
        woStartWay: 0,
        woTitle: "留言工单",
        woType: "",
        woTypeId: this.typeId,
        woTypeName: this.typeName,
      };
      if (this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          param.woFileRelVoList.push({
            fileName: this.fileList[i].name,
            fileType: this.fileList[i].suffix,
            fileUrl: this.fileList[i].url,
          });
        }
      }
      if (this.extendsField.length > 0) {
        for (let i = 0; i < this.extendsField.length; i++) {
          if (
            this.extendsField[i].requiredStatus &&
            this.extendsField[i].chooseValue == ""
          ) {
            // 必填评价
            Toast({
              message: this.$t("pleInput") + this.extendsField[i].fieldName,
              duration: 3000,
            });
            return;
          }
          if (this.extendsField[i].fieldType == 8) {
            param.cusFieldConfigInfoVoList.push({
              fieldId: this.extendsField[i].fieldId,
              fieldValue: this.extendsField[i].chooseName.join(","),
              fieldName: this.extendsField[i].fieldName,
            });
          } else {
            param.cusFieldConfigInfoVoList.push({
              fieldId: this.extendsField[i].fieldId,
              fieldValue: this.extendsField[i].chooseValue,
              fieldName: this.extendsField[i].fieldName,
            });
          }
        }
      }

      request.addWo(param).then((res) => {
        console.log(res, "tijiao");
        store.dispatch("setConfigPc", [
          { key: "showModal", value: false },
          {
            key: "messageModal",
            value: false,
          },
        ]);
        this.$emit("closePopup");
      });
    },
    close() {
      this.$emit("closePopup");
    },
    showDetail(item) {
      this.showFlag = true;

      request
        .woinfo({
          id: item.woId,
        })
        .then((res) => {
          console.log(res);
          this.orderDetail = res.data;
        });
    },
    getRes(res) {
      console.log(res);
    },
    changeFile(file, fileList) {
      console.log(fileList);
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      console.log(fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    checkFileExist(file, fileList) {
      const files = file; //获取文件
      let Arr = [
        ".jpg",
        ".png",
        ".mp4",
        ".mov",".jpeg",".avc",".heic",".hevc"
      ];
      let fileName = files.name;
      let fileIndex = fileName.lastIndexOf(".");
      let substrName = fileName.substr(fileIndex);
      if (Arr.indexOf(substrName) < 0) {
        this.$message({
          type: "error",
          message: this.$t("onlyIMG"),
        });
        file.target.value = null;
        return false;
      }
      if (file.size > 5242880 * 10) {
        Message({
          message: window.vm.$i18n.t("fileMax"),
          type: "error",
        });
        return false;
      }
      const obj = {
        file: files,
        userId: store.state.userInfo.userId,
      };
      this.fileList = [];
      request.uploadFile(obj).then((result) => {
        if (result.code === 200) {
          console.log(result, "fj");
          this.fileList.push(result.data);
        }
      });
      return false
    },

    beforeRemove(file, fileList) {
      return this.$confirm("delete" + ` ${file.name}？`);
    },
    addWoHandleInfo() {
      console.log(this.orderDetail);
      var param = {
        userId: store.state.userInfo.userId,
        tenantId: store.state.initData.tenantId,
        woId: this.orderDetail.woId,
        handleContent: this.msgContent,
        woFileRelVoList: [],
        woTypeId: this.typeId,
      };
      if (this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          param.woFileRelVoList.push({
            fileName: this.fileList[i].name,
            fileType: this.fileList[i].suffix,
            fileUrl: this.fileList[i].url,
          });
        }
      }

      request.addWoHandleInfo(param).then((res) => {
        console.log(res);
        store.dispatch("setConfigPc", [
          { key: "showModal", value: false },
          {
            key: "messageModal",
            value: false,
          },
        ]);
      });
    },
    showGFN() {
      this.showGroup = true;
    },
  },
};
</script>

<style scoped>
.eval {
  background: white;
  height: 100%;
  width: 100%;
}

.eval_title {
  height: 44px;
  background: #f5f6f9;
  color: #2a2a2c;
  font-size: 14px;
  text-align: left;
  position: relative;
}

.eval_title span {
  margin: 5px 15px;
  display: inline-block;
  line-height: 34px;
  text-align: left;
  cursor: pointer;
}

.eval_title .active {
  color: #6c5df9;
}

.eval_close {
  position: absolute;
  right: 5px;
  top: 8px;
  font-size: 20px;
  width: 25px;
  color: #999;
  height: 25px;
  margin: 0 !important;
}

.eval_close::before {
  content: "\2716";
}

.eval_body {
  margin: 0 30px 38px;
  text-align: left;
  height: calc(80vh - 44px);
  position: relative;
}

.eval_body button {
  background: #7467f0;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  left: 0;
  right: 0;
}

.eval_desc {
  font-size: 14px;
  line-height: 20px;
  margin: 10px;
  text-align: center;
}

.eval_body input {
  display: block;
  outline: none;
  border: 0.5px solid #e6e6e6;
  background: #ffffff;
  color: #999999;
  font-size: 14px;
  width: 100%;
  height: 40px;
  border-radius: 2px;
  margin-bottom: 16px;
  box-sizing: border-box;
  padding-left: 10px;
}

.required {
  color: red;
  font-size: 15px;
  vertical-align: bottom;
}

.label {
  display: inline-block;
  margin: 5px;
  line-height: 20px;
  font-size: 14px;
  color: #2a2a2c;
}

.leave_msg_item {
  line-height: 12px;
  margin: 10px 5px;
  padding: 5px;
  background: #fafafa;
}

.leave_msg_item div {
  text-align: left;
  font-size: 16px;
  line-height: 18px;
  margin: 8px 0;
}

.leave_msg_item .label {
  width: 112px;
  display: inline-block;
  text-align: right;
  padding-left: 3px;
  color: #666;
}

.leave_msg_item .time {
  width: 216px;
  display: inline-block;
  text-align: center;
  padding-left: 3px;
  color: #666;
}

.leave_msg_item .woStatus {
  float: right;
  display: block;
  background: #7467f0;
  color: #fff;
  width: 80px;
  text-align: center;
}

.leave_msg_item .woContent {
  width: 100% !important;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
}

.leave_msg_item .label + span {
  width: 60px;
}

.file {
  width: 70px;
  background: #6c5df9;
  position: relative;
  display: block;
  height: 26px;
}

.file a {
  position: absolute;
  left: 20px;
  line-height: 26px;
  font-size: 14px;
  color: #ffffff;
}

.file input {
  opacity: 0;
}

.mt10 {
  margin-top: 8px;
}

.uploadBtn {
  padding: 5px 10px;
}

.el-steps--vertical {
  height: auto;
}

.top-tip-txt {
  margin: 6px 0 16px;
  font-size: 12px;
  font-weight: 300;
  color: #a1a7b3;
}

.top-tip-txt p {
  margin-bottom: 0;
  word-break: break-word;
}

.font12 {
  font-size: 12px !important;
}

::v-deep .el-step__title {
  font-size: 12px;
}

::v-deep .el-step__head.is-success {
  color: rgb(52, 158, 250);
  border-color: rgb(52, 158, 250);
}

::v-deep .el-step__title.is-success {
  font-weight: bold;
  color: rgb(52, 158, 250);
}

::v-deep .el-step__description.is-success {
  color: rgb(52, 158, 250);
}
.mt20 {
  margin-top: 20px;
}

.h300 {
  overflow-y: scroll;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/h5/message.vue